import React from "react";
import LearningCalendarContent from "../FunctionComponents/LearningCalendar/LearningCalendarContent";

function LearningCalendar() {
  return (
    <>
      <LearningCalendarContent />
    </>
  );
}

export default LearningCalendar;
